<template>
  <div class="info">
    <div class="btns">
      <div class="b-wrap">
        <el-button @click="navBack">返回</el-button>
      </div>
    </div>
    <div class="i-items">
      <div class="i-item-head">
        <div class="i-title">项目</div>
        <div class="i-detail">内容</div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">报名编号</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.id }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">申报单位</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent( info.companyName)"></div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">营业执照照片</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.businessLicense"
                v-for="(item, index) in info.businessLicense"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.businessLicense" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品名称</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent(info.productName )"></div>
          </div>
        </div>
      </div>
         <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品类型</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent( info.productType)"></div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品原产地</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent( info.originCountry )"></div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品包装图</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.productWrap"
                v-for="(item, index) in info.productWrap"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.productWrap" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品实拍图</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.productReal"
                v-for="(item, index) in info.productReal"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.productReal" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品资质</div>
          <div class="i-detail">
            <div class="i-imgs" v-if="info.another && info.another.length > 0">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.another"
                v-for="(item, index) in info.another"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.another" :key="index" /> -->
            </div>
            <span v-else>未传图片</span>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">商品类型</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-if="info.productQualification == 1">
              生鲜
            </div>
            <div class="i-d-wrap" v-if="info.productQualification == 2">
              保健品
            </div>
            <div class="i-d-wrap" v-if="info.productQualification == 3">
              其他
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productQualification == 1">
        <div class="i-info">
          <div class="i-title">采购协议</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.freshAgreement"
                v-for="(item, index) in info.freshAgreement"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.freshAgreement" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productQualification == 2">
        <div class="i-info">
          <div class="i-title">保健品批准证</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.approvalCertificate"
                v-for="(item, index) in info.approvalCertificate"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.approvalCertificate" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productQualification == 2">
        <div class="i-info">
          <div class="i-title">保健品卫生许可证</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.sanitaryPermit"
                v-for="(item, index) in info.sanitaryPermit"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.sanitaryPermit" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">其他证书</div>
          <div class="i-detail">
            <div
              class="i-imgs"
              v-if="info.otherProductQualification.length > 0"
            >
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.otherProductQualification"
                v-for="(item, index) in info.otherProductQualification"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.otherProductQualification" :key="index"/> -->
            </div>
            <span v-else>未传图片</span>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">商标</div>
          <div class="i-detail">
            <div class="i-d-wrap">
              {{ info.brandRegisterCard == 1 ? "自持" : "第三方转让" }}
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">商标注册证正面</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.brandRegisterCardFront"
                v-for="(item, index) in info.brandRegisterCardFront"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.brandRegisterCardFront" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">商标注册证反面</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.brandRegisterCardBack"
                v-for="(item, index) in info.brandRegisterCardBack"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.brandRegisterCardBack" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.brandRegisterCard == 2">
        <div class="i-info">
          <div class="i-title">第三方营业执照复印件</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.thirdBusinessLicense"
                v-for="(item, index) in info.thirdBusinessLicense"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.thirdBusinessLicense" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.brandRegisterCard == 2">
        <div class="i-info">
          <div class="i-title">转让说明</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.brandRegisterCardDesc }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">生产方式</div>
          <div class="i-detail">
            <div class="i-d-wrap">
              {{ info.productMode == "1" ? "自己生产" : "委托生产" }}
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productMode == 1">
        <div class="i-info">
          <div class="i-title">生产许可证</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.productPermit"
                v-for="(item, index) in info.productPermit"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.productPermit" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productMode == 2">
        <div class="i-info">
          <div class="i-title">委托方生产许可证</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.delegateProductPermit"
                v-for="(item, index) in info.delegateProductPermit"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.delegateProductPermit" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productMode == 2">
        <div class="i-info">
          <div class="i-title">委托方营业执照</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.delegateBusinessLicense"
                v-for="(item, index) in info.delegateBusinessLicense"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.delegateBusinessLicense" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item" v-if="info.productMode == 2">
        <div class="i-info">
          <div class="i-title">委托方加工协议</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.delegateProcessingDeal"
                v-for="(item, index) in info.delegateProcessingDeal"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.delegateProcessingDeal" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">质检合格报告</div>
          <div class="i-detail">
            <div class="i-imgs">
              <el-img
                fit="cover"
                :src="item"
                :preview-src-list="info.qualityInspectionReport"
                v-for="(item, index) in info.qualityInspectionReport"
                :key="index"
              ></el-img>
              <!-- <img :src="item" v-for="(item, index) in info.qualityInspectionReport" :key="index"/> -->
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品上市时间</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.marketTime }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">年产量</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.yearlyOutput }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">年销售额</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.yearlySales }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">现有销售渠道</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.existingSalesChannel }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">网络销售渠道</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.networkSalesChannel }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">网络销售占比</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.networkSalesRatio }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品销售旺季</div>
          <div class="i-detail">
            <div
              class="i-d-wrap"
              v-for="(item, index) in info.salesSeason"
              :key="index"
            >
              {{ item }}月<span v-if="index < info.salesSeason.length - 1"
                >，</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">产品介绍</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent( info.productSellingPoint)"></div>
          </div>
        </div>
      </div>
     
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">姓名</div>
          <div class="i-detail">
            <div class="i-d-wrap" v-html="showcontent(info.contactUser)"></div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">手机</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.contactPhone }}</div>
          </div>
        </div>
      </div>
      <div class="i-item">
        <div class="i-info">
          <div class="i-title">微信</div>
          <div class="i-detail">
            <div class="i-d-wrap">{{ info.wxNo }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { query } from "@/api/api";
import { Image } from "element-ui";
import { showcontent } from "@/utils/method.js";


export default {
  data() {
    return {
      info: {
        another: [],
        otherProductQualification: [],
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      this.queryInfo();
    }
  },
  activated() {
        if (this.$route.query.id) {
      this.queryInfo();
    }
  },
  methods: {
    showcontent,
    queryInfo() {
      this.$ajaxPost("/company/query", { id: this.$route.query.id }).then((res ) => {
      // this.$api.post(query, { id: this.$route.query.id }, (res) => {
        // const imgReg = /^\[(.*)\]$/i;
        const imgReg = /\.(jpg|jpeg|png|JPG|PNG)$/;
        console.log(imgReg.test('png'));
        if (res.data.code == "0") {
          // debugger
          const resData = res.data.data;
          const keys = Object.keys(resData);
          for (const key of keys) {
            if (resData[key]) {
              let element = resData[key];
              if (imgReg.test(element)) {
                if (element.includes(',')) {
                  resData[key] = resData[key].split(",");
                } else {
                  resData[key] = [resData[key]]
                }
              }else if(key == 'salesSeason'){
                  resData[key] = resData[key].split(",");
              }
            }
          }
          // keys.forEach((key) => {
          //   // console.log(resData[key].split(','));
          //   // debugger
          //   console.log(resData[key].includes("png" || "jpg"));
          //   if (
          //     resData[key].includes("png" || "jpg") &&
          //     key != "listVerifyRecord" &&
          //     resData[key]
          //   ) {
          //     // debugger
          //     resData[key] = resData[key].split(",");
          //     console.log(resData[key]);
          //     // resData[key] = (JSON.parse(resData[key]))
          //   }
          // });
          keys.forEach((key) => {
            resData[key + "_checked"] = false;
          });
          console.log(resData);
          this.info = resData;
        } else {
          this.$message(res.data.message);
        }
      }).catch((error) => {
          this.$message({
            type: "danger",
            message:error,
          });
        });
    },
    navBack() {
      this.$router.go(-1);
    },
  },
  components: {
    "el-img": Image,
  },
};
</script>

<style lang="less" scoped>
.info {
  padding: 10px;
  background: #fff;
  margin-top: -10px;
  .el-image{
    width: 100px !important;
    height: 100px !important;
    margin-right: 10px !important;
  }
  .is-checked {
    .el-checkbox__label {
      color: #dd6161 !important;
    }

    .el-checkbox__inner {
      background-color: #dd6161;
      border-color: #dd6161;
    }
  }

  .header .el-top {
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;

    .title {
      font-size: 16px;
      font-weight: 400;
      margin: 0;
    }
  }

  .btns {
    width: 100%;
    margin-top: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e8e8e8;
  }

  .i-items {
    width: 90%;
    margin-top: 20px;
    border: 1px solid #d8d8d8;
    border-radius: 10px;

    .i-item {
      width: 100%;
      display: flex;
      align-items: center;
    }

    & > .i-item:last-child .i-info {
      border-bottom: none;
    }

    .i-item-head {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      color: #3f3f3f;
      border-bottom: 1px solid #e8e8e8;
      font-size: 14px;
      background-color: #f2f2f2;

      & > div {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    .i-info {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #727272;
      border-bottom: 1px solid #d8d8d8;

      & > div {
        min-height: 40px;
        display: flex;
        align-items: center;
      }
    }

    .i-title {
      width: 20%;
      padding-left: 8px;
      box-sizing: border-box;
    }

    .i-detail {
      width: 80%;
      padding-left: 8px;
      box-sizing: border-box;
      border-left: 1px solid #e9e9e9;
    }

    .i-check {
      width: 20%;
      padding-left: 8px;
      box-sizing: border-box;
      display: none;
    }

    .i-imgs {
      padding: 10px 0;
      padding-top: 20px;

      img {
        width: 90px;
        height: 90px;
        margin-right: 10px;
        margin-bottom: 10px;
        object-fit: cover;
      }
    }
  }
}
</style>
